var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotate-clockwise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.502 3.35988C7.36697 3.35649 6.26962 3.76687 5.41535 4.51421C4.56109 5.26155 4.00847 6.29462 3.86096 7.42002C3.8131 7.78508 3.47837 8.04224 3.1133 7.99439C2.74823 7.94653 2.49108 7.6118 2.53893 7.24673C2.7286 5.79978 3.4391 4.47156 4.53744 3.51069C5.63578 2.54983 7.04667 2.02219 8.50598 2.02655C9.9653 2.03092 11.373 2.56698 12.4656 3.5344C13.5582 4.50182 14.2607 5.83427 14.4417 7.28232C14.6227 8.73037 14.2698 10.1948 13.4489 11.4014C12.6281 12.6079 11.3957 13.474 9.98235 13.8375C8.56901 14.2009 7.07166 14.0368 5.77059 13.3759C5.03248 13.0009 4.38625 12.4806 3.86661 11.8531L3.86661 13.3334C3.86661 13.7016 3.56813 14 3.19994 14C2.83176 14 2.53328 13.7016 2.53328 13.3334L2.53328 10C2.53328 9.63185 2.83176 9.33337 3.19994 9.33337H3.51776C3.52799 9.33314 3.53821 9.33314 3.5484 9.33337H6.53328C6.90147 9.33337 7.19994 9.63185 7.19994 10C7.19994 10.3682 6.90147 10.6667 6.53328 10.6667H4.64002C5.07879 11.3062 5.67333 11.831 6.37447 12.1871C7.38641 12.7012 8.55102 12.8288 9.65028 12.5462C10.7495 12.2635 11.7081 11.5899 12.3465 10.6514C12.9849 9.71293 13.2595 8.57396 13.1187 7.4477C12.9779 6.32143 12.4315 5.28509 11.5817 4.53265C10.7319 3.78021 9.63702 3.36328 8.502 3.35988Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.195ff652aca49de93becf225c501bbfc.svg";
export { ForwardRef as ReactComponent };